.tooltip {
	--tooltip-background: var(--gray-900);
	--arrow-size: 10px;
	--show-duration: 0.2s;
	--hide-duration: 0.1s;
	--hidden-opacity: 0;
	--hidden-scale: 0.95;

	&[data-side="top"] {
		margin-top: calc(var(--offset-size) * -1);
		transform-origin: center bottom;
		transform-origin: calc(attr(data-arrow px) + var(--arrow-size) / 2) bottom;
	}
	&[data-side="bottom"] {
		margin-bottom: calc(var(--offset-size) * -1);
		transform-origin: center top;
		transform-origin: calc(attr(data-arrow px) + var(--arrow-size) / 2) top;
	}
	&[data-side="left"] {
		margin-left: calc(var(--offset-size) * -1);
		transform-origin: right center;
		transform-origin: right calc(attr(data-arrow px) + var(--arrow-size) / 2);
	}
	&[data-side="right"] {
		margin-right: calc(var(--offset-size) * -1);
		transform-origin: left center;
		transform-origin: left calc(attr(data-arrow px) + var(--arrow-size) / 2);
	}

	overflow: visible;
	padding: var(--size-2) var(--size-3);
	font-size: var(--text-caption);
	line-height: 1.5;
	background-color: var(--tooltip-background);
	border: var(--size-border) solid var(--color-border);
	background-clip: padding-box;
	color: var(--gray-100);
	border-radius: var(--radius-lg);
	width: max-content;
	max-width: var(--max-width, 16rem);

	/* enter and leave animations */
	display: none;
	opacity: var(--hidden-opacity);
	scale: var(--hidden-scale);
	transition:
		display var(--hide-duration) allow-discrete,
		overlay var(--hide-duration) allow-discrete,
		scale var(--hide-duration) ease,
		opacity var(--hide-duration) ease;

	&:popover-open {
		display: block;
		opacity: 1;
		scale: 1;
		translate: 0;
		transition-duration: var(--show-duration);

		@starting-style {
			opacity: var(--hidden-opacity);
			scale: var(--hidden-scale);
		}
	}
}

.arrow {
	position: absolute;
	border: calc(var(--arrow-size) / 2) solid transparent;

	.tooltip[data-side="top"] & {
		bottom: calc(var(--arrow-size) * -1 + 1px);
		border-top-color: var(--tooltip-background);
	}

	.tooltip[data-side="bottom"] & {
		top: calc(var(--arrow-size) * -1 + 1px);
		border-bottom-color: var(--tooltip-background);
	}

	.tooltip[data-side="left"] & {
		right: calc(var(--arrow-size) * -1 + 1px);
		border-left-color: var(--tooltip-background);
	}

	.tooltip[data-side="right"] & {
		left: calc(var(--arrow-size) * -1 + 1px);
		border-right-color: var(--tooltip-background);
	}
}
